import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { useTheme, Card, CardContent, Typography, List, ListItem, ListItemText, Box } from "@mui/material";

// Register Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const DevicePackage = ({ Dashdata }) => {
  const theme = useTheme();

  // Extract data from props
  const taken = Dashdata?.total_devices || 0;
  const applied = Dashdata?.licensed_devices || 0;
  const remaining = Dashdata?.unlicensed_devices || 0;

  // Chart data
  const data = {
    labels: ["Applied", "Pending"],
    datasets: [
      {
        data: [applied, remaining],
        backgroundColor: [theme.palette.primary.main, theme.palette.secondary.main],
        borderWidth: 0,
      },
    ],
  };

  // Chart options
  const options = {
    cutout: "70%",
    plugins: {
      legend: { display: false },
      datalabels: { display: false },
      tooltip: {
        enabled: true,
        callbacks: {
          label: (context) => {
            const label = context.label || "";
            const value = context.raw || 0;
            return `${label}: ${value}`;
          },
        },
      },
    },
    maintainAspectRatio: false,
  };

  return (
    <Card
      sx={{
        maxWidth: 262,
        width: "100%",
        p: 2,
        borderRadius: 3,
        boxShadow: 3,
        transition: "all 0.3s",
        "&:hover": { boxShadow: 6 },
      }}
    >
      <CardContent sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        {/* Title */}
        <Typography
          variant="subtitle1"
          sx={{
            color: "#595C60",
            fontWeight: 600,
            mb: 2,
            fontFamily: "Nunito Sans, sans-serif",
          }}
        >
          Total Devices: {taken}
        </Typography>

        {/* Donut Chart */}
        <Box sx={{ width: 128, height: 128, mb: 2 }}>
          <Doughnut data={data} options={options} />
        </Box>

        {/* License Details */}
        <List sx={{ width: "100%", mt: 1, px: 0 }}>
          <ListItem disablePadding sx={{ display: "flex", justifyContent: "space-between" }}>
            <ListItemText
              primary="Applied"
              primaryTypographyProps={{ fontWeight: 600, color: theme.palette.primary.main }}
            />
            <Typography>{applied}</Typography>
          </ListItem>
          <ListItem disablePadding sx={{ display: "flex", justifyContent: "space-between" }}>
            <ListItemText
              primary="Pending"
              primaryTypographyProps={{ fontWeight: 600, color: theme.palette.secondary.main }}
            />
            <Typography>{remaining}</Typography>
          </ListItem>
          <ListItem
            disablePadding
            sx={{
              display: "flex",
              justifyContent: "space-between",
              borderTop: "1px solid #e0e0e0",
              mt: 1,
              pt: 1,
            }}
          >
            <ListItemText
              primary="Total Devices"
              primaryTypographyProps={{ fontWeight: 600, color: "#595C60" }}
            />
            <Typography>{taken}</Typography>
          </ListItem>
        </List>
      </CardContent>
    </Card>
  );
};

export default DevicePackage;
